import React, { useEffect, useState } from "react";
import SubscriptionModal from "./SubscriptionModal";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import Paper from "@mui/material/Paper";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Select,
  TextField,
  FormLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { call } from "services/axiosService/core";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Payment from "./payment";
import Coupon from "./Coupon";
import PaymentSetupWrapper from "./PaymentSetupWrapper";
import { setProfile } from "context";
import TermsAndConditionsPDF from "../../assets/pdf/Terms&Conditions.pdf";
import PaymentTermsPDF from "../../assets/pdf/Payment_Terms.pdf";
import { useNavigate } from "react-router-dom";
import BulkUpload from "./BulkUpload";
import Refresh from "pages/refresh/Refresh";
import { useAuthenticator } from "@aws-amplify/ui-react";
import * as Sentry from "@sentry/browser";
import { useTranslation } from "react-i18next";

const EditChildrenButton = ({ row, handleOpenEditChildModal, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.edit")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon fontSize="medium" color="info" onClick={() => handleOpenEditChildModal(row)}>
          edit
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const DeleteChildrenButton = ({ row, handleOpenDeleteModal, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.delete")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon fontSize="medium" color="error" onClick={() => handleOpenDeleteModal(row)}>
          delete
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const PaymentButton = ({ row, handleOpenPaymentModal, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.payment")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon fontSize="medium" color="info" onClick={() => handleOpenPaymentModal(row)}>
          payment
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const SendInviteButton = ({ row, handleOpenInviteEmailModal, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.email")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon fontSize="medium" color="info" onClick={() => handleOpenInviteEmailModal(row)}>
          email
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const ResetPasswordButton = ({ id, ResetPasswordHandler, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}> {t("toolTips.reset_password")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon
          fontSize="medium"
          color="info"
          onClick={() => {
            ResetPasswordHandler(id);
          }}
        >
          lock_reset
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const RequiredLabel = ({ children }) => {
  const { t } = useTranslation();
  return (
    <FormLabel
      sx={{
        display: "flex",
        color: "black",
        alignItems: "center",
        margin: "10px auto 2px",
        fontSize: "1.05rem",
        fontWeight: 900,
      }}
    >
      <span style={{ color: "red", fontSize: "small", marginRight: "5px" }}>*</span>
      {children}
      <span style={{ color: "red", fontSize: "small", marginLeft: "10px" }}>
        {t("formLabels.required")}
      </span>
    </FormLabel>
  );
};

const ChildrenTable = ({
  childrenDetails,
  getChildrens,
  loader,
  setSessionExpired,
  openAddChild,
  openPayment,
}) => {
  const { t } = useTranslation();
  const [controller, dispatch] = useMaterialUIController();
  const [children, setchildren] = useState(childrenDetails);
  const [childForPayment, setChildForPayment] = useState({});
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState("maxu_yearly");
  const [openAddChildModal, setOpenAddChildModal] = useState(false);
  const [openAddAthleteModal, setOpenAddAthleteModal] = useState(false);
  const [adding, setAdding] = useState("asParent");
  const [openBulkUploadModal, setOpenBulkUploadModal] = useState(openAddChild);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openInstructionModal, setOpenInstructionModal] = useState(false);
  const [selectedChild, setSelectedChild] = useState({});
  const [openInviteEmailModal, setOpenInviteEmailModal] = useState(false);
  const [openPaymentSuccessModal, setOpenPaymentSuccessModal] = useState(false);
  const [addNewPaymentMethod, setAddNewPaymentMethod] = useState(false);
  const [openAddPaymentMethodModal, setOpenAddPaymentMethodModal] = useState(false);
  const [openChildSummaryModal, setOpenChildSummaryModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteChildId, setDeleteChildId] = useState();
  const [editChildData, setEditChildData] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [pageNumber, SetPageNumber] = useState(0);
  const [severity, setSeverity] = useState("info");
  const [selectUserId, setSelectUserId] = useState("");
  const [openResetPasswordDialog, setOpenResetPasswordDialog] = useState(false);
  const { profile, persona } = controller;
  const isSharedAccount = profile.type && profile.type.includes("Shared");
  const navigate = useNavigate();
  const handleOpenAddChildModal = () => setOpenAddChildModal(true);
  const handleOpenAddAthleteModal = () => setOpenAddAthleteModal(true);
  // const handleOpenAddPaymentMethodModal = () => setOpenAddPaymentMethodModal(true);
  const handleCloseAddChildModal = () => setOpenAddChildModal(false);
  const handleCloseAddAthleteModal = () => setOpenAddAthleteModal(false);
  const handleCloseEditModal = () => setOpenEditModal(false);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  const handleCloseChildSummaryModal = () => setOpenChildSummaryModal(false);

  const handleCloseAddPaymentMethodModal = async () => {
    await updateUserProfile();
    if (profile.id == childForPayment.id) {
      navigate("/mylearnerdashboard", { state: true });
    }
    setOpenAddPaymentMethodModal(false);
    setChildForPayment({});
    setOpenInstructionModal(true);
  };

  const handleClosePaymentSuccessModal = (shouldAdd = false) => {
    setOpenPaymentSuccessModal(false);
    if (shouldAdd) {
      setOpenAddPaymentMethodModal(true);
    } else if (profile.id == childForPayment.id) {
      navigate("/mylearnerdashboard", { state: true });
    } else {
      setOpenInstructionModal(true);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleCloseInstructionModal = () => {
    setOpenInstructionModal(false);
  };

  const handleCloseSubscriptionModal = (sub) => {
    setSubscriptionType(sub);
    setOpenSubscriptionModal(false);
    setOpenPaymentModal(true);
    // if (childForPayment.is_demo_user) {
    //   updateChildPaymentStatus(childForPayment);
    // } else {
    //   setOpenPaymentModal(true);
    // }
  };

  const handleClosePaymentModal = async (payment_status, shouldAdd = false) => {
    await updateUserProfile();
    setOpenPaymentModal(false);
    if (payment_status == "success") {
      setOpenPaymentSuccessModal(true);
    } else if (payment_status == "PaymentNotRequired") {
      handleClosePaymentSuccessModal(shouldAdd);
    }
    getChildrens();
  };

  const handleOpenEditChildModal = (child) => {
    setEditChildData(child);
    setOpenEditModal(true);
  };

  const handleOpenDeleteModal = (child) => {
    setDeleteChildId(child.id);
    setOpenDeleteModal(true);
  };

  const handleOpenChildSummaryModal = () => {
    setOpenChildSummaryModal(true);
  };

  // const handleOpenSubscriptionModal = (child) => {
  //   setChildForPayment(child);
  //   setOpenSubscriptionModal(true);
  // };

  const handleOpenInstructionModal = (child) => {
    setOpenAddAthleteModal(false);
    setOpenAddChildModal(false);
    setOpenInstructionModal(true);
    // setChildForPayment(child);
  };

  const handleOpenBulkUploadModal = (option) => {
    if (option == "asCoach") {
      setAdding("asCoach");
      setOpenBulkUploadModal(true);
    } else {
      setAdding("asParent");
      setOpenBulkUploadModal(true);
    }
  };

  const handleCloseBulkUploadModal = () => {
    setOpenBulkUploadModal(false);
    setAdding("asParent");
  };

  const updateChildPaymentStatus = (LearnerDetails) => {
    LearnerDetails.payment_status = "success";
    LearnerDetails.paid_at = new Date();
    LearnerDetails.is_demo_user = true;
    LearnerDetails.subscription_type = subscriptionType;
    call(`users/${LearnerDetails.id}`, "PUT", {
      body: LearnerDetails,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response.status == 200) {
          getChildrens();
          setOpenInstructionModal(true);
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
        console.log(error);
      });
  };

  const handleOpenPaymentModal = (child) => {
    setOpenAddChildModal(false);
    setOpenAddAthleteModal(false);
    setChildForPayment(child);
    if (profile.true_mindsets) {
      setOpenSubscriptionModal(true);
    } else {
      setOpenPaymentModal(true);
      // if (child.is_demo_user) {
      //   updateChildPaymentStatus(child);
      // } else {
      //   setOpenPaymentModal(true);
      // }
    }
  };

  const handleOpenInviteEmailModal = (child) => {
    setOpenInviteEmailModal(true);
    setSelectedChild(child);
  };

  const handleCloseInviteEmailModal = () => {
    setOpenInviteEmailModal(false);
    setSelectedChild({});
  };

  const updateUserProfile = () => {
    call(`users/${profile.id}`, "GET", {
      body: profile,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response.status == 200) {
          setProfile(dispatch, response.data);
        } else if (response.status == 440) {
          setSessionExpired(true);
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
        console.log(err, "err");
      });
  };

  const CloseResetPasswordDialogHandler = () => {
    setOpenResetPasswordDialog(false);
    // setSelectedId("");
  };

  const ResetPasswordHandler = (id) => {
    setSelectUserId(id);
    setOpenResetPasswordDialog(true);
  };

  const handleSharedAccountDelete = () => {
    setAlertMessage(t("alerts.profile.sharedAccountDeleteNotAvailable"));
    setSeverity("info");
    setOpenSnackbar(true);
  };

  useEffect(() => {
    if (openPayment) {
      handleOpenPaymentModal(profile);
    }
  }, []);

  const childrenData = {
    columns: [
      { Header: t("tableHeaders.name"), accessor: "name", width: "20%" },
      { Header: t("tableHeaders.relation"), accessor: "relation", width: "20%" },
      { Header: t("tableHeaders.email"), accessor: "email", width: "20%" },
      { Header: t("tableHeaders.gender"), accessor: "gender", width: "10%", align: "center" },
      { Header: t("tableHeaders.dob"), accessor: "dob", width: "10%" },
      { Header: t("tableHeaders.status"), accessor: "status", width: "10%" },
      { Header: t("tableHeaders.payment_status"), accessor: "payment_status", width: "10%" },
      { Header: t("tableHeaders.actions"), accessor: "actions", width: "15%" },
    ],
    rows: childrenDetails,
  };

  function formatToMMDDYYYY(dateStr) {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${month}-${day}-${year}`;
  }

  childrenData.rows = childrenData.rows.map((row) => {
    const isShared = row.type && row.type.includes("Shared");
    const details =
      isShared && row.details.learner_details ? row.details.learner_details : row.details;

    return {
      id: row.id,
      gender: details.gender ? t(`userDynamicData.${details.gender.toLowerCase()}`) : "",
      status: t(`userDynamicData.${row.status}`),
      payment_status: t(`userDynamicData.${row.payment_status}`),
      name:
        isShared ? details.name + " (" + t("userDynamicData.shared") + ")" :
        row.id == profile.id
          ? details.name + " (" + t("userDynamicData.owner") + ")"
          : details.name,
      relation: row.relation ? t(`userDynamicData.${row.relation.toLowerCase()}`) : null,
      dob: formatToMMDDYYYY(details.dob),
      email: row.email,
      actions: (
        <div style={{ display: "flex" }}>
          {((!row.is_adult && row.id != profile.id && !isShared) ||
            (isShared && row.id == profile.id)) && (
            <div style={{ display: "flex" }}>
              <EditChildrenButton
                row={row}
                handleOpenEditChildModal={handleOpenEditChildModal}
                t={t}
              />
              <DeleteChildrenButton
                row={row}
                handleOpenDeleteModal={
                  isShared ? handleSharedAccountDelete : handleOpenDeleteModal
                }
                t={t}
              />
            </div>
          )}
          {row.payment_status != "success" && (
            <PaymentButton row={row} handleOpenPaymentModal={handleOpenPaymentModal} t={t} />
          )}
          {row.status != "active" && (
            <SendInviteButton
              row={row}
              handleOpenInviteEmailModal={handleOpenInviteEmailModal}
              t={t}
            />
          )}

          {row.status != "active" && row.cognito_user_id && (
            <ResetPasswordButton id={row.id} ResetPasswordHandler={ResetPasswordHandler} t={t} />
          )}
        </div>
      ),
    };
  });
  return (
    <>
      <MDBox mt={1} mb={1}>
        <Card>
          <MDBox p={1} lineHeight={1}>
            <MDTypography variant="h4" fontWeight="medium">
              {t("headings.learners")}
            </MDTypography>
          </MDBox>
          <DataTable
            table={childrenData}
            loader={loader}
            pageNumber={pageNumber}
            SetPageNumber={SetPageNumber}
            noData={true}
            clickHandler={handleOpenAddChildModal}
            canSearch={true}
          />
        </Card>
      </MDBox>
      {!isSharedAccount && (
         <MDBox display="flex" justifyContent="space-between" gap={2} m={2}>
         <Button
           onClick={() => handleOpenBulkUploadModal("asParent")}
           variant="contained"
           sx={{
             backgroundColor: "#10B0D5",
             color: "#fff",
             "&:hover": {
               backgroundColor: "#089ebe",
               color: "#fff",
             },
             textTransform: "none",
             fontSize: "14px",
             borderRadius: "12px",
             px: 3,
             py: 1.5,
           }}
         >
           {t("buttonTitles.addAsParent")}
         </Button>
 
         <Button
           onClick={() => handleOpenBulkUploadModal("asCoach")}
           variant="contained"
           sx={{
             backgroundColor: "#10B0D5",
             color: "#fff",
             "&:hover": {
               backgroundColor: "#089ebe",
               color: "#fff",
             },
             textTransform: "none",
             borderRadius: "12px",
             fontSize: "14px",
             px: 3,
             py: 1.5,
           }}
         >
           {t("buttonTitles.addAsCoach")}
         </Button>
 
         {/* Uncomment if needed */}
 
         {/* <Button
           onClick={handleOpenChildSummaryModal}
           variant="contained"
           sx={{
             backgroundColor: "#F6821E",
             color: "#fff",
             "&:hover": {
               backgroundColor: "#d86f18",
             },
             textTransform: "none",
             borderRadius: "12px",
             px: 3,
             py: 1.5,
           }}
         >
           Learners Summary Report
         </Button> */}
       </MDBox>
      )}

     

      {openAddChildModal && (
        <AddChildModal
          openAddChildModal={openAddChildModal}
          handleCloseAddChildModal={handleCloseAddChildModal}
          getChildrens={getChildrens}
          updateUserProfile={updateUserProfile}
          handleOpenPaymentModal={handleOpenPaymentModal}
          handleOpenInstructionModal={handleOpenInstructionModal}
          setOpenAddChildModal={setOpenAddChildModal}
          profile={profile}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          setSessionExpired={setSessionExpired}
          t={t}
        />
      )}

      {openAddAthleteModal && (
        <AddAthleteModal
          openAddAthleteModal={openAddAthleteModal}
          handleCloseAddAthleteModal={handleCloseAddAthleteModal}
          getChildrens={getChildrens}
          updateUserProfile={updateUserProfile}
          handleOpenPaymentModal={handleOpenPaymentModal}
          handleOpenInstructionModal={handleOpenInstructionModal}
          setOpenAddAthleteModal={setOpenAddAthleteModal}
          profile={profile}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          setSessionExpired={setSessionExpired}
          t={t}
        />
      )}

      {openEditModal && (
        <EditChildModal
          openEditModal={openEditModal}
          handleCloseEditModal={handleCloseEditModal}
          editChildData={editChildData}
          getChildrens={getChildrens}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          setSessionExpired={setSessionExpired}
          t={t}
        />
      )}

      {openDeleteModal && (
        <DeleteChildModal
          openDeleteModal={openDeleteModal}
          handleCloseDeleteModal={handleCloseDeleteModal}
          getChildrens={getChildrens}
          updateUserProfile={updateUserProfile}
          deleteChildId={deleteChildId}
          setAlertMessage={setAlertMessage}
          setOpenSnackbar={setOpenSnackbar}
          setSeverity={setSeverity}
          setSessionExpired={setSessionExpired}
          t={t}
        />
      )}

      {openInstructionModal && (
        <InstructionModal
          openInstructionModal={openInstructionModal}
          handleCloseInstructionModal={handleCloseInstructionModal}
          t={t}
        />
      )}

      {openSubscriptionModal && (
        <MAXUSubscriptionModal
          openSubscriptionModal={openSubscriptionModal}
          handleCloseSubscriptionModal={handleCloseSubscriptionModal}
          subscriptionType={subscriptionType}
          setSubscriptionType={setSubscriptionType}
        />
      )}

      {openPaymentModal && (
        <PaymentModal
          openPaymentModal={openPaymentModal}
          handleClosePaymentModal={handleClosePaymentModal}
          childDetails={childForPayment}
          setSessionExpired={setSessionExpired}
          subscriptionType={subscriptionType}
          t={t}
        />
      )}

      {openAddPaymentMethodModal && (
        <PaymentSetupWrapper
          openAddPaymentMethodModal={openAddPaymentMethodModal}
          handleCloseAddPaymentMethodModal={handleCloseAddPaymentMethodModal}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          setSessionExpired={setSessionExpired}
          addNewPaymentMethod={addNewPaymentMethod}
          childDetails={childForPayment}
          t={t}
        />
      )}

      {openPaymentSuccessModal && (
        <PaymentSuccessModal
          openPaymentSuccessModal={openPaymentSuccessModal}
          handleClosePaymentSuccessModal={handleClosePaymentSuccessModal}
          t={t}
        />
      )}
      {openChildSummaryModal && (
        <ChildSummaryModal
          openChildSummaryModal={openChildSummaryModal}
          handleCloseChildSummaryModal={handleCloseChildSummaryModal}
          profile={profile}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          setSessionExpired={setSessionExpired}
          t={t}
        />
      )}

      {openBulkUploadModal && (
        <BulkUpload
          adding={adding}
          trueMindsUser={profile.true_mindsets}
          setOpenAddAthleteModal={setOpenAddAthleteModal}
          setOpenAddChildModal={setOpenAddChildModal}
          handleCloseBulkUploadModal={handleCloseBulkUploadModal}
          getChildrens={getChildrens}
          updateUserProfile={updateUserProfile}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          setSessionExpired={setSessionExpired}
          setProfile={setProfile}
          t={t}
        />
      )}

      {openInviteEmailModal && (
        <SendInviteEmailModal
          selectedChild={selectedChild}
          handleCloseInviteEmailModal={handleCloseInviteEmailModal}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          setSessionExpired={setSessionExpired}
          profile={profile}
          t={t}
        />
      )}

      {openResetPasswordDialog && (
        <ResetPasswordDialog
          openResetPasswordDialog={openResetPasswordDialog}
          CloseResetPasswordDialogHandler={CloseResetPasswordDialogHandler}
          selectUserId={selectUserId}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSessionExpired={setSessionExpired}
          t={t}
        />
      )}

      <Snackbar
        autoHideDuration={4000}
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={severity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

const SendInviteEmailModal = ({
  selectedChild,
  handleCloseInviteEmailModal,
  setOpenSnackbar,
  setAlertMessage,
  setSeverity,
  setSessionExpired,
  profile,
  t,
}) => {
  const { signOut } = useAuthenticator((context) => [context.user]);
  const email = selectedChild.email;
  const recipient_id = selectedChild.id;

  const onSendEmail = () => {
    call(`users/${profile.id}/emails`, "POST", {
      body: { email_type: "send_signup_reminder_notification", recipient_id: recipient_id },
    })
      .then((response) => {
        if (response.status == 200) {
          setAlertMessage(t("alerts.dashboard.insightReminderSuccess"));
          setOpenSnackbar(true);
          setSeverity("success");
          handleCloseInviteEmailModal();
        } else if (response.status == 440) {
          setSessionExpired(true);
        } else {
          setAlertMessage(t("alerts.dashboard.insightReminderError"));
          setOpenSnackbar(true);
          setSeverity("error");
          handleCloseInviteEmailModal();
        }
      })
      .catch(function (err) {
        setAlertMessage(t("alerts.dashboard.insightReminderError"));
        setOpenSnackbar(true);
        setSeverity("error");
        handleCloseInviteEmailModal();
        console.log(err);
        Sentry.captureException(err);
      });
  };

  // const onCreateChildAccount = async () => {
  //   await signOut();
  // };

  return (
    <Dialog open={true}>
      <CloseIcon
        fontSize="medium"
        onClick={handleCloseInviteEmailModal}
        style={{
          color: "red",
          display: "block",
          marginLeft: "auto",
          cursor: "pointer",
        }}
      />

      <DialogTitle>
        <Typography variant="h4" ma={1}>
          <MDTypography variant="h4" mb={1}>
            {t("childSignupInstruction.title")}
          </MDTypography>
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="body1"
          fontSize={16}
          textAlign="left"
          sx={{ whiteSpace: "normal", lineHeight: 1.7 }}
          mb={2}
        >
          {t("childSignupInstruction.thankYou")}
        </Typography>

        <Typography
          variant="body1"
          fontSize={16}
          sx={{ whiteSpace: "normal", lineHeight: 1.7 }}
          mb={2}
          dangerouslySetInnerHTML={{
            __html: t("childSignupInstruction.nextStep", { email }),
          }}
        ></Typography>

        <Typography
          variant="h6"
          fontSize={18}
          sx={{ whiteSpace: "normal", lineHeight: 1.7 }}
          mb={1}
        >
          {t("childSignupInstruction.instructionsTitle")}
        </Typography>

        <ul style={{ paddingLeft: "20px", marginTop: 0, marginBottom: "20px" }}>
          <li>{t("childSignupInstruction.step1")}</li>
          <li>{t("childSignupInstruction.step2")}</li>
          <li>{t("childSignupInstruction.step3")}</li>
        </ul>

        <Typography
          variant="body1"
          fontSize={16}
          sx={{ whiteSpace: "normal", lineHeight: 1.7 }}
          mb={2}
        >
          {t("childSignupInstruction.assessmentReady")}
        </Typography>

        <Typography
          variant="h6"
          fontSize={16}
          sx={{ whiteSpace: "normal", lineHeight: 1.7 }}
          mb={1}
        >
          {t("childSignupInstruction.optionsTitle")}
        </Typography>

        <ul style={{ paddingLeft: "20px", marginTop: 0 }}>
          <li
            dangerouslySetInnerHTML={{
              __html: t("childSignupInstruction.optionSendEmail"),
            }}
          ></li>
        </ul>
        <Typography
          variant="body2"
          fontSize={14}
          color="text.secondary"
          sx={{ whiteSpace: "normal", lineHeight: 1.6 }}
          mt={2}
          dangerouslySetInnerHTML={{
            __html: t("childSignupInstruction.note"),
          }}
        ></Typography>

        <MDBox display="flex" justifyContent="flex-end" mt={3}>
          <Button
            type="button"
            onClick={onSendEmail}
            style={{
              color: "white",
              background: "#f6821e",
            }}
          >
            {t("childSignupInstruction.sendEmailBtn")}
          </Button>
        </MDBox>
      </DialogContent>
    </Dialog>
  );
};
const MAXUSubscriptionModal = ({
  openSubscriptionModal,
  handleCloseSubscriptionModal,
  subscriptionType,
  setSubscriptionType,
}) => {
  return (
    <Dialog open={openSubscriptionModal}>
      <DialogContent>
        <SubscriptionModal isOpen={true} onClose={handleCloseSubscriptionModal} />
      </DialogContent>
    </Dialog>
  );
};

const InstructionModal = ({ openInstructionModal, handleCloseInstructionModal, t }) => {
  // const { signOut } = useAuthenticator((context) => [context.user]);

  // const handleSignupChild = async () => {
  //   await signOut();
  // };

  return (
    <Dialog open={openInstructionModal}>
      {/* <CloseIcon
        fontSize="medium"
        onClick={() => {
          handleCloseInstructionModal();
        }}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      /> */}

      <DialogContent>
        <Typography
          variant="body1"
          fontSize={16}
          textAlign="left"
          sx={{ whiteSpace: "normal", lineHeight: 1.7 }}
          dangerouslySetInnerHTML={{ __html: t("messages.subscription.thankyouMessageChild") }}
        />

        <MDBox display="flex" justifyContent="space-between" mt={2}>
          {/* <Button
            type="button"
            onClick={handleSignupChild}
            style={{
              color: "white",
              background: "#f6821e",
            }}
          >
            {t("buttonTitles.signupChild")}
          </Button> */}

          <Button
            type="button"
            onClick={handleCloseInstructionModal}
            style={{
              color: "white",
              background: "#10B0D5",
            }}
          >
            {t("buttonTitles.close")}
          </Button>
        </MDBox>
      </DialogContent>
    </Dialog>
  );
};
const PaymentModal = ({
  openPaymentModal,
  childDetails,
  handleClosePaymentModal,
  setSessionExpired,
  subscriptionType,
  t,
}) => {
  const [controller] = useMaterialUIController();
  const { profile } = controller;
  const [amountToProcess, setAmountToProcess] = useState(
    subscriptionType == "true_mindsets_yearly"
      ? 480
      : subscriptionType == "true_mindsets_monthly"
      ? 45
      : 99
  );
  const [proceedToPayment, setProceedtoPayment] = useState(false);
  const [couponUsed, setCouponUsed] = useState(null);

  return (
    <Dialog open={openPaymentModal}>
      <CloseIcon
        fontSize="medium"
        onClick={() => {
          handleClosePaymentModal("pending");
        }}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogTitle>
        <Typography variant="h4" textAlign="center" mb={1}>
          {t("headings.maxuPayment")}
        </Typography>
        {subscriptionType == "maxu_yearly" ? (
          profile.id == childDetails.id ? (
            <Typography variant="h6" textAlign="center" mb={2}>
              {t(`messages.subscription.maxuAnnualFee`, { amount: amountToProcess })}
            </Typography>
          ) : (
            <Typography variant="h6" textAlign="center" mb={2}>
              {t(`messages.subscription.maxuAnnualFeeChild`, { amount: amountToProcess })}
            </Typography>
          )
        ) : profile.id == childDetails.id ? (
          <Typography variant="h6" textAlign="center" mb={2}>
            {subscriptionType == "true_mindsets_monthly"
              ? t(`messages.subscription.trueMindsetsAnnualMonthly`, { amount: amountToProcess })
              : t(`messages.subscription.trueMindsetsAnnual`, { amount: amountToProcess })}
          </Typography>
        ) : (
          <Typography variant="h6" textAlign="center" mb={2}>
            {subscriptionType == "true_mindsets_monthly"
              ? t(`messages.subscription.trueMindsetsAnnualMonthlyChild`, {
                  amount: amountToProcess,
                })
              : t(`messages.subscription.trueMindsetsAnnualMonthlyChild`, {
                  amount: amountToProcess,
                })}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        {!proceedToPayment && (
          <Coupon
            setAmountToProcess={setAmountToProcess}
            setProceedtoPayment={setProceedtoPayment}
            handleClosePaymentModal={handleClosePaymentModal}
            childDetails={childDetails}
            setSessionExpired={setSessionExpired}
            setCouponUsed={setCouponUsed}
            subscriptionType={subscriptionType}
          />
        )}
        {proceedToPayment && (
          <Payment
            childDetails={childDetails}
            handleClosePaymentModal={handleClosePaymentModal}
            amountToProcess={amountToProcess}
            setSessionExpired={setSessionExpired}
            couponUsed={couponUsed}
            subscriptionType={subscriptionType}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

const AddChildModal = ({
  openAddChildModal,
  handleCloseAddChildModal,
  getChildrens,
  updateUserProfile,
  handleOpenPaymentModal,
  handleOpenInstructionModal,
  setOpenAddChildModal,
  profile,
  setOpenSnackbar,
  setAlertMessage,
  setSeverity,
  setSessionExpired,
  t,
}) => {
  // const [addChild, setAddChild] = useState({
  //   name: "",
  //   lastName:"",
  //   email: "",
  //   gender: "Male",
  //   dob: "",
  //   status: "inactive",
  // });
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("Male");
  const [dob, setDob] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [termsConditionsChecked, setTermsConditionsChecked] = useState(false);
  const [paymentTermsChecked, setPaymentTermsChecked] = useState(false);

  useEffect(() => {
    let today = new Date();
    // Parents can add childrens above 12  and below 18 only
    // Giving  limit to the date picker acording to that dates only.
    // if today is MAY-15-2023 start date will be MAY-16-2005(below 18) end date will be MAY-15-2011 (above 12 years)

    let end_date = new Date(
      today.getFullYear() - 8,
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setEndDate(end_date.toISOString().slice(0, 10));
    let start_date = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate() + 1,
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setStartDate(start_date.toISOString().slice(0, 10));
  }, []);
  // const onChangeAddChildHandler = (e) => {
  //   setAddChild({ ...addChild, [e.target.name]: e.target.value });
  // };

  const addChildSubmitHandler = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const currentDate = new Date();
    const nameValue = firstName + " " + lastName;
    const body = {
      email: email,
      phone: null,
      relationships: {
        parents: [profile.id],
      },
      type: ["Learner"],
      language: profile.language ? profile.language : "en",
      is_demo_user: false,
      status: "inactive",
      true_mindsets: profile.true_mindsets ? true : false,
      source: profile.source,
      details: {
        name: nameValue,
        dob: dob,
        persona: ["Athlete"],
        gender: gender,
        address: {
          street: null,
          city: null,
          state: null,
          country: null,
          zip: null,
        },
      },
      payment_status: "pending",
      profile_image_url: null,
      identities: [
        {
          google: {
            id: "",
          },
          facebook: {
            id: "",
          },
          apple: {
            id: "",
          },
          amazon: {
            id: "",
          },
          email: {
            id: "",
          },
        },
      ],
    };
    call("users", "POST", {
      body: body,
      params: { add_as: "parent" },
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response) {
          if (response.status == 403 || response.status == 404 || response.status == 400) {
            setSeverity("error");
            setOpenSnackbar(true);
            setOpenAddChildModal(false);
            setAlertMessage(response.data.message);
          } else if (response.status == 200) {
            setSeverity("success");
            setOpenSnackbar(true);
            setAlertMessage(t("alerts.profile.childAddedSuccessfully"));
            getChildrens();
            updateUserProfile();
            // handleOpenInstructionModal(response.data);
            handleOpenPaymentModal(response.data);
            setIsLoading(false);
          } else if (response.status == 440) {
            setOpenAddChildModal(false);
            setSessionExpired(true);
          } else {
            setSeverity("error");
            setOpenSnackbar(true);
            setAlertMessage(t("alerts.profile.childAddedError"));
          }
        } else {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
        setOpenAddChildModal(false);
        setIsLoading(false);
        console.log(err, "err");
      });
  };

  const termsConditionsCheckboxHandler = () => {
    setTermsConditionsChecked(!termsConditionsChecked);
  };

  const paymentTermsCheckboxHandler = () => {
    setPaymentTermsChecked(!paymentTermsChecked);
  };

  return (
    <Dialog open={openAddChildModal} close={handleCloseAddChildModal}>
      <CloseIcon
        fontSize="medium"
        aria-label="close"
        onClick={handleCloseAddChildModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogTitle tabindex="0">
        <Typography variant="h4" textAlign="center" mb={2}>
          {t("headings.addLearner")}
        </Typography>
        <Typography variant="h6" textAlign="center" mb={2}>
          {t("messages.profile.addAsParent")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={addChildSubmitHandler}>
          <RequiredLabel>{t("formLabels.firstName")}:</RequiredLabel>
          <MDInput
            value={firstName}
            placeholder={t("formPlaceHolders.firstName")}
            rows="1"
            name="firstName"
            aria-label="First Name"
            aria-required="true"
            type="text"
            onChange={(e) => {
              if (e.nativeEvent.data != " ") {
                setFirstName(e.target.value);
              }
            }}
            fullWidth
            required
          />

          <RequiredLabel>{t("formLabels.lastName")}:</RequiredLabel>
          <MDInput
            value={lastName}
            placeholder={t("formPlaceHolders.lastName")}
            aria-label="Last Name"
            aria-required="true"
            rows="1"
            name="lastName"
            type="text"
            onChange={(e) => {
              if (e.nativeEvent.data != " ") {
                setLastName(e.target.value);
              }
            }}
            fullWidth
            required
          />
          <RequiredLabel>{t("formLabels.email")}:</RequiredLabel>
          <MDInput
            value={email}
            placeholder={t("formPlaceHolders.email")}
            aria-label={"Email"}
            aria-required="true"
            rows="1"
            name="email"
            type="email"
            onChange={(e) => {
              if (e.nativeEvent.data != " ") {
                setEmail(e.target.value);
              }
            }}
            fullWidth
            required
          />
          <RequiredLabel>{t("formLabels.gender")}:</RequiredLabel>
          <FormControl fullWidth>
            <Select
              style={{ height: "48px" }}
              value={gender}
              onChange={(e) => {
                setGender(e.target.value);
              }}
              aria-label={"Select Gender"}
              name="gender"
            >
              <MenuItem aria-label="Male" value="Male">
                {t("formLabels.male")}
              </MenuItem>
              <MenuItem aria-label="Female" value="Female">
                {t("formLabels.female")}
              </MenuItem>
            </Select>
          </FormControl>
          <RequiredLabel>{t("formLabels.birthdate")}</RequiredLabel>
          <TextField
            type="date"
            id="dob"
            aria-describedby="my-helper-text"
            name="dob"
            onChange={(e) => setDob(e.target.value)}
            value={dob}
            inputProps={{
              "aria-label": "Enter Child/Athlete's Date of Birth",
              min: startDate,
              max: endDate,
            }}
            required
            fullWidth
            style={{ display: "block" }}
          />
          <FormGroup sx={{ marginTop: "10px" }}>
            <MDBox display="flex" direction="row" gap={1}>
              <MDTypography variant="h6" style={{ paddingTop: "10px" }}>
                <Checkbox
                  required
                  inputProps={{ "aria-label": t("formLabels.termsAndConditions") }}
                  checked={termsConditionsChecked}
                  onChange={termsConditionsCheckboxHandler}
                />
              </MDTypography>
              <MDTypography variant="h6" style={{ paddingTop: "18px" }}>
                <span style={{ color: "red", fontSize: "small", paddingRight: "5px" }}>*</span>
                {t("formLabels.termsAndConditions")}
                <Typography
                  component="a"
                  fontSize={15}
                  color="#10b0d5"
                  href={"/terms_conditions"}
                  target="_blank"
                  style={{ paddingTop: "15px" }}
                >
                  {" "}
                  {t("formLabels.terms")}
                </Typography>
                <span style={{ color: "red", fontSize: "small", marginLeft: "10px" }}>
                  {t("formLabels.required")}
                </span>
              </MDTypography>
            </MDBox>
            <MDBox display="flex" direction="row" gap={1}>
              <MDTypography style={{ paddingTop: "10px" }}>
                <Checkbox
                  required
                  inputProps={{ "aria-label": t("formLabels.paymentTerms") }}
                  checked={paymentTermsChecked}
                  onChange={paymentTermsCheckboxHandler}
                />
              </MDTypography>
              <MDTypography variant="h6" style={{ paddingTop: "18px" }}>
                <span style={{ color: "red", fontSize: "small", paddingRight: "5px" }}>*</span>
                {t("formLabels.termsAndConditions")}
                <Typography
                  component="a"
                  fontSize={15}
                  color="#10b0d5"
                  href={"/payment_terms"}
                  target="_blank"
                  style={{ paddingTop: "15px" }}
                >
                  {" "}
                  {t("formLabels.paymentTerms")}
                </Typography>
                <span style={{ color: "red", fontSize: "small", marginLeft: "10px" }}>
                  {t("formLabels.required")}
                </span>
              </MDTypography>
            </MDBox>
          </FormGroup>

          <MDBox display="flex" justifyContent="end">
            <Button
              type="submit"
              style={{
                color: "white",
                background: "#10B0D5",
                marginTop: "15px",
                display: "flex",
                justifyContent: "end",
              }}
            >
              {isLoading ? <CircularProgress color="white" size={20} /> : t("buttonTitles.next")}
            </Button>
          </MDBox>
        </form>
      </DialogContent>
    </Dialog>
  );
};

const AddAthleteModal = ({
  openAddAthleteModal,
  handleCloseAddAthleteModal,
  getChildrens,
  updateUserProfile,
  handleOpenPaymentModal,
  handleOpenInstructionModal,
  setOpenAddAthleteModal,
  profile,
  setOpenSnackbar,
  setAlertMessage,
  setSeverity,
  setSessionExpired,
  t,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [parentEmail, setParentEmail] = useState("");
  const [gender, setGender] = useState("Male");
  const [dob, setDob] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [termsConditionsChecked, setTermsConditionsChecked] = useState(false);
  const [paymentTermsChecked, setPaymentTermsChecked] = useState(false);

  // Calculate age from dob
  const calculateAge = (birthDate) => {
    if (!birthDate) return null;
    const diff_ms = Date.now() - new Date(birthDate).getTime();
    const age_dt = new Date(diff_ms);
    return Math.abs(age_dt.getUTCFullYear() - 1970);
  };

  const userAge = calculateAge(dob);
  const isMinor = userAge !== null && userAge < 18;

  useEffect(() => {
    let today = new Date();
    // Coaches can add Athlete above 8
    // Giving  limit to the date picker acording to that dates only.
    // if today is MAY-15-2023 start date will be MAY-16-2005(below 18) end date will be MAY-15-2011 (above 12 years)
    let end_date = new Date(
      today.getFullYear() - 8,
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setEndDate(end_date.toISOString().slice(0, 10));
  }, []);

  const handleApiResponse = (response) => {
    if (response) {
      if (response.status == 403 || response.status == 404 || response.status == 400) {
        setSeverity("error");
        setOpenSnackbar(true);
        setOpenAddAthleteModal(false);
        setAlertMessage(response.data.message);
      } else if (response.status == 200) {
        setSeverity("success");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.childAddedSuccessfully"));
        getChildrens();
        updateUserProfile();
        handleOpenPaymentModal(response.data);
        setIsLoading(false);
      } else if (response.status == 440) {
        setOpenAddAthleteModal(false);
        setSessionExpired(true);
      } else {
        setSeverity("error");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.childAddedError"));
      }
    } else {
      setIsLoading(false);
    }
  };

  const handleApiError = (err) => {
    Sentry.captureException(err);
    setOpenAddAthleteModal(false);
    setIsLoading(false);
    console.log(err, "err");
  };

  const addAthleteSubmitHandler = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const nameValue = firstName + " " + lastName;
    const user_age = calculateAge(dob);

    const learnerDetails = {
      name: nameValue,
      dob: dob,
      gender: gender,
      persona: ["Athlete"],
    };

    // Case 1: User is 18+ (Adult) - original flow
    if (user_age >= 18) {
      const body = {
        email: email,
        phone: null,
        relationships: {
          coaches: [profile.id],
          children: [],
        },
        type: ["Learner", "Adult"],
        language: profile.language ? profile.language : "en",
        is_demo_user: false,
        true_mindsets: profile.true_mindsets ? true : false,
        source: profile.source,
        status: "inactive",
        details: {
          ...learnerDetails,
          address: {
            street: null,
            city: null,
            state: null,
            country: null,
            zip: null,
          },
        },
        payment_status: "pending",
        profile_image_url: null,
        identities: [
          {
            google: { id: "" },
            facebook: { id: "" },
            apple: { id: "" },
            amazon: { id: "" },
            email: { id: "" },
          },
        ],
      };

      call("users", "POST", {
        body: body,
        params: { add_as: "coach" },
        headers: { "Content-Type": "application/json" },
      })
        .then(handleApiResponse)
        .catch(handleApiError);
    }
    // Case 2: Minor with only learner email (no parent email) - original flow for minors
    else if (email && !parentEmail) {
      const body = {
        email: email,
        phone: null,
        relationships: {
          coaches: [profile.id],
        },
        type: ["Learner"],
        language: profile.language ? profile.language : "en",
        is_demo_user: false,
        true_mindsets: profile.true_mindsets ? true : false,
        source: profile.source,
        status: "inactive",
        details: {
          ...learnerDetails,
          address: {
            street: null,
            city: null,
            state: null,
            country: null,
            zip: null,
          },
        },
        payment_status: "pending",
        profile_image_url: null,
        identities: [
          {
            google: { id: "" },
            facebook: { id: "" },
            apple: { id: "" },
            amazon: { id: "" },
            email: { id: "" },
          },
        ],
      };

      call("users", "POST", {
        body: body,
        params: { add_as: "coach" },
        headers: { "Content-Type": "application/json" },
      })
        .then(handleApiResponse)
        .catch(handleApiError);
    }
    // Case 3: Minor with only parent email - create shared account
    else if (parentEmail && !email) {
      const body = {
        email: parentEmail,
        phone: null,
        relationships: {
          coaches: [profile.id],
          children: [],
        },
        type: ["Learner", "Shared"],
        language: profile.language ? profile.language : "en",
        is_demo_user: false,
        true_mindsets: profile.true_mindsets ? true : false,
        source: profile.source,
        status: "inactive",
        details: {
          name: null,
          address: {},
          dob: null,
          gender: null,
          persona: ["Parent"],
          learner_details: learnerDetails,
        },
        payment_status: "pending",
        profile_image_url: null,
        identities: [
          {
            google: { id: "" },
            facebook: { id: "" },
            apple: { id: "" },
            amazon: { id: "" },
            email: { id: "" },
          },
        ],
      };

      call("users", "POST", {
        body: body,
        params: { add_as: "coach", account_type: "shared" },
        headers: { "Content-Type": "application/json" },
      })
        .then(handleApiResponse)
        .catch(handleApiError);
    }
    // Case 4: Minor with both learner and parent email - create separate accounts with shared relation
    else if (email && parentEmail) {
      const body = {
        email: email,
        parent_email: parentEmail,
        phone: null,
        relationships: {
          coaches: [profile.id],
          parents: [],
        },
        type: ["Learner"],
        language: profile.language ? profile.language : "en",
        is_demo_user: false,
        true_mindsets: profile.true_mindsets ? true : false,
        source: profile.source,
        status: "inactive",
        details: {
          ...learnerDetails,
          address: {
            street: null,
            city: null,
            state: null,
            country: null,
            zip: null,
          },
        },
        payment_status: "pending",
        profile_image_url: null,
        identities: [
          {
            google: { id: "" },
            facebook: { id: "" },
            apple: { id: "" },
            amazon: { id: "" },
            email: { id: "" },
          },
        ],
      };

      call("users", "POST", {
        body: body,
        params: { add_as: "coach", account_type: "separate" },
        headers: { "Content-Type": "application/json" },
      })
        .then(handleApiResponse)
        .catch(handleApiError);
    }
  };

  const termsConditionsCheckboxHandler = () => {
    setTermsConditionsChecked(!termsConditionsChecked);
  };

  const paymentTermsCheckboxHandler = () => {
    setPaymentTermsChecked(!paymentTermsChecked);
  };

  return (
    <Dialog open={openAddAthleteModal} close={handleCloseAddAthleteModal}>
      <CloseIcon
        fontSize="medium"
        onClick={handleCloseAddAthleteModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogTitle>
        <Typography variant="h4" textAlign="center" mb={2}>
          {t("headings.addLearner")}
        </Typography>
        <Typography variant="h6" textAlign="center" mb={2}>
          {t("messages.profile.addAsCoach")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={addAthleteSubmitHandler}>
          <RequiredLabel>{t("formLabels.firstName")}</RequiredLabel>
          <MDInput
            value={firstName}
            placeholder={t("formPlaceHolders.firstName")}
            rows="1"
            name="firstName"
            type="text"
            onChange={(e) => {
              if (e.nativeEvent.data != " ") {
                setFirstName(e.target.value);
              }
            }}
            fullWidth
            required
          />
          <RequiredLabel>{t("formLabels.lastName")}</RequiredLabel>
          <MDInput
            value={lastName}
            placeholder={t("formPlaceHolders.lastName")}
            rows="1"
            name="lastName"
            type="text"
            onChange={(e) => {
              if (e.nativeEvent.data != " ") {
                setLastName(e.target.value);
              }
            }}
            fullWidth
            required
          />
          <RequiredLabel>{t("formLabels.gender")}</RequiredLabel>
          <FormControl fullWidth>
            <Select
              style={{ height: "48px" }}
              value={gender}
              onChange={(e) => {
                setGender(e.target.value);
              }}
              name="gender"
            >
              <MenuItem value="Male">{t("formLabels.male")}</MenuItem>
              <MenuItem value="Female">{t("formLabels.female")}</MenuItem>
            </Select>
          </FormControl>
          <RequiredLabel>{t("formLabels.birthdate")}:</RequiredLabel>
          <TextField
            type="date"
            name="dob"
            onChange={(e) => {
              setDob(e.target.value);
              // Reset emails when DOB changes
              setEmail("");
              setParentEmail("");
            }}
            value={dob}
            inputProps={{ min: startDate, max: endDate }}
            required
            fullWidth
            style={{ display: "block" }}
          />

          {/* For 18+ users: show only learner email (required) */}
          {dob && !isMinor && (
            <>
              <RequiredLabel>{t("formLabels.learnerEmail")}</RequiredLabel>
              <MDInput
                value={email}
                placeholder={t("formPlaceHolders.email")}
                rows="1"
                name="email"
                type="email"
                onChange={(e) => {
                  if (e.nativeEvent.data != " ") {
                    setEmail(e.target.value);
                  }
                }}
                fullWidth
                required
              />
            </>
          )}

          {/* For minors: show both email options */}
          {dob && isMinor && (
            <>
              <RequiredLabel>{t("formLabels.email")}</RequiredLabel>
              <Typography
                variant="body2"
                sx={{ mb: 1, color: "text.secondary", fontStyle: "italic", fontSize: "0.85rem" }}
              >
                {t("formLabels.minorEmailNote")}
              </Typography>

              <FormLabel
                sx={{
                  display: "flex",
                  color: "black",
                  alignItems: "center",
                  margin: "4px auto 2px",
                  paddingLeft: "12px",
                  fontSize: "0.95rem",
                  fontWeight: 700,
                }}
              >
                {t("formLabels.learnerEmail")}
              </FormLabel>
              <MDBox sx={{ pl: 1.5, pb: 1 }}>
                <MDInput
                  value={email}
                  placeholder={t("formPlaceHolders.email")}
                  rows="1"
                  name="email"
                  type="email"
                  onChange={(e) => {
                    if (e.nativeEvent.data != " ") {
                      setEmail(e.target.value);
                    }
                  }}
                  fullWidth
                  required={!parentEmail}
                />
              </MDBox>

              <FormLabel
                sx={{
                  display: "flex",
                  color: "black",
                  alignItems: "center",
                  margin: "4px auto 2px",
                  paddingLeft: "12px",
                  fontSize: "0.95rem",
                  fontWeight: 700,
                }}
              >
                <span style={{ color: "text.secondary", fontStyle: "italic", marginRight: "6px" }}>
                  ({t("formLabels.or")})
                </span>
                {t("formLabels.parentEmail")}
              </FormLabel>
              <MDBox sx={{ pl: 1.5 }}>
                <MDInput
                  value={parentEmail}
                  placeholder={t("formPlaceHolders.parentEmail")}
                  rows="1"
                  name="parentEmail"
                  type="email"
                  onChange={(e) => {
                    if (e.nativeEvent.data != " ") {
                      setParentEmail(e.target.value);
                    }
                  }}
                  fullWidth
                  required={!email}
                />
              </MDBox>
            </>
          )}

          <FormGroup sx={{ marginTop: "10px" }}>
            <MDBox display="flex" direction="row" gap={1}>
              <MDTypography variant="h6" style={{ paddingTop: "10px" }}>
                <Checkbox
                  required
                  inputProps={{ "aria-label": t("formLabels.termsAndConditions") }}
                  checked={termsConditionsChecked}
                  onChange={termsConditionsCheckboxHandler}
                />
              </MDTypography>
              <MDTypography variant="h6" style={{ paddingTop: "18px" }}>
                <span style={{ color: "red", fontSize: "small", paddingRight: "5px" }}>*</span>
                {t("formLabels.termsAndConditions")}
                <Typography
                  component="a"
                  fontSize={15}
                  color="#10b0d5"
                  href={"/terms_conditions"}
                  target="_blank"
                  style={{ paddingTop: "15px" }}
                >
                  {" "}
                  {t("formLabels.terms")}
                </Typography>
                <span style={{ color: "red", fontSize: "small", marginLeft: "10px" }}>
                  {t("formLabels.required")}
                </span>
              </MDTypography>
            </MDBox>
            <MDBox display="flex" direction="row" gap={1}>
              <MDTypography style={{ paddingTop: "10px" }}>
                <Checkbox
                  required
                  inputProps={{ "aria-label": t("formLabels.paymentTerms") }}
                  checked={paymentTermsChecked}
                  onChange={paymentTermsCheckboxHandler}
                />
              </MDTypography>
              <MDTypography variant="h6" style={{ paddingTop: "18px" }}>
                <span style={{ color: "red", fontSize: "small", paddingRight: "5px" }}>*</span>
                {t("formLabels.termsAndConditions")}
                <Typography
                  component="a"
                  fontSize={15}
                  color="#10b0d5"
                  href={"/payment_terms"}
                  target="_blank"
                  style={{ paddingTop: "15px" }}
                >
                  {" "}
                  {t("formLabels.paymentTerms")}
                </Typography>
                <span style={{ color: "red", fontSize: "small", marginLeft: "10px" }}>
                  {t("formLabels.required")}
                </span>
              </MDTypography>
            </MDBox>
          </FormGroup>

          <MDBox display="flex" justifyContent="end">
            <Button
              type="submit"
              disabled={isMinor && !email && !parentEmail}
              style={{
                color: "white",
                background: isMinor && !email && !parentEmail ? "#ccc" : "#10B0D5",
                marginTop: "15px",
                display: "flex",
                justifyContent: "end",
              }}
            >
              {isLoading ? <CircularProgress color="white" size={20} /> : t("buttonTitles.next")}
            </Button>
          </MDBox>
        </form>
      </DialogContent>
    </Dialog>
  );
};

const EditChildModal = ({
  openEditModal,
  handleCloseEditModal,
  editChildData,
  getChildrens,
  setAlertMessage,
  setOpenSnackbar,
  setSeverity,
  setSessionExpired,
  t,
}) => {
  const [editChild, setEditChild] = useState({ name: "", gender: "", dob: "" });
  const isSharedEdit =
    editChildData.type && editChildData.type.includes("Shared");
  const editDetails =
    isSharedEdit && editChildData.details.learner_details
      ? editChildData.details.learner_details
      : editChildData.details;
  const [firstName, setFirstName] = useState(editDetails.name.split(" ")[0]);
  const [lastName, setLastName] = useState(editDetails.name.split(" ")[1] ?? null);
  const [gender, setGender] = useState(editDetails.gender);
  const [dob, setDob] = useState(editDetails.dob);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  useEffect(() => {
    let year = 8;
    if (editChildData.relation == "Child") {
      year = 8;
    }
    let today = new Date();
    let end_date = new Date(
      today.getFullYear() - year,
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setEndDate(end_date.toISOString().slice(0, 10));
    // setEndDate(today.toISOString().slice(0, 10));
    let start_date = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate() + 1,
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setStartDate(start_date.toISOString().slice(0, 10));
  }, []);

  const editHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (isSharedEdit && editChildData.details.learner_details) {
      editChildData.details.learner_details.name = firstName + " " + lastName;
      editChildData.details.learner_details.gender = gender;
      editChildData.details.learner_details.dob = dob;
    } else {
      editChildData.details.name = firstName + " " + lastName;
      editChildData.details.gender = gender;
      editChildData.details.dob = dob;
    }

    call(`users/${editChildData.id}`, "PUT", {
      body: editChildData,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response.status == 200) {
          setSeverity("success");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childUpdatedSuccessfully"));
          setIsLoading(false);
          handleCloseEditModal();
          getChildrens();
        } else if (response.status == 403 || response.status == 404 || response.status == 400) {
          setSeverity("error");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childUpdatedError"));
          setIsLoading(false);
          handleCloseEditModal();
          getChildrens();
        } else if (response.status == 440) {
          setIsLoading(false);
          handleCloseEditModal();
          setSessionExpired(true);
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
        setSeverity("error");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.childUpdatedError"));
        setIsLoading(false);
        handleCloseEditModal();
        console.log(error);
      });
  };
  return (
    <Dialog open={openEditModal} close={handleCloseEditModal} fullWidth={true} maxWidth="xs">
      <CloseIcon
        fontSize="medium"
        aria-label="close"
        onClick={handleCloseEditModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogTitle sx={{ textAlign: "center" }} tabindex="0">
        <Typography variant="h4" mb={1}>
          {t("headings.editLearner")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={editHandler}>
          <RequiredLabel>{t("formLabels.firstName")}:</RequiredLabel>
          <MDInput
            inputProps={{ "aria-label": "First Name" }}
            value={firstName}
            placeholder={t("formPlaceHolders.firstName")}
            rows="1"
            name="firstName"
            type="text"
            onChange={(e) => {
              if (e.nativeEvent.data != " ") {
                setFirstName(e.target.value);
              }
            }}
            multiline
            fullWidth
            required
          />
          <RequiredLabel> {t("formLabels.lastName")}</RequiredLabel>
          <MDInput
            inputProps={{ "aria-label": "Last Name" }}
            value={lastName}
            rows="1"
            placeholder={t("formPlaceHolders.lastName")}
            name="lastName"
            type="text"
            onChange={(e) => {
              if (e.nativeEvent.data != " ") {
                setLastName(e.target.value);
              }
            }}
            multiline
            fullWidth
            required
          />
          <RequiredLabel> {t("formLabels.gender")}</RequiredLabel>
          <FormControl fullWidth>
            <Select
              aria-label={"Select Gender"}
              style={{ height: "48px" }}
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              name="gender"
            >
              <MenuItem aria-label={"Male"} value="Male">
                {t("formLabels.male")}
              </MenuItem>
              <MenuItem aria-label={"Female"} value="Female">
                {t("formLabels.female")}
              </MenuItem>
            </Select>
          </FormControl>
          <RequiredLabel> {t("formLabels.birthdate")}: </RequiredLabel>
          <TextField
            type="date"
            name="dob"
            fullWidth
            required
            onChange={(e) => {
              setDob(e.target.value);
            }}
            value={dob}
            inputProps={{ min: startDate, max: endDate }}
            style={{ display: "block" }}
          />
          <MDBox display="flex" justifyContent="center">
            <Button
              type="submit"
              style={{
                marginTop: "15px",
                color: "white",
                background: "#10B0D5",
              }}
            >
              {isLoading ? (
                <CircularProgress color="white" size={30} />
              ) : (
                t("buttonTitles.saveChanges")
              )}
            </Button>
          </MDBox>
        </form>
      </DialogContent>
    </Dialog>
  );
};

const DeleteChildModal = ({
  openDeleteModal,
  handleCloseDeleteModal,
  getChildrens,
  updateUserProfile,
  deleteChildId,
  setAlertMessage,
  setOpenSnackbar,
  setSeverity,
  setSessionExpired,
  t,
}) => {
  const deleteHandler = () => {
    call(`users/${deleteChildId}`, "DELETE", { params: { type: "children" } })
      .then((response) => {
        if (response.status == 200) {
          getChildrens();
          updateUserProfile();
          setSeverity("success");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childDeletedSuccessfully"));
          handleCloseDeleteModal();
        } else if (response.status == 440) {
          handleCloseDeleteModal();
          setSessionExpired(true);
        } else {
          setSeverity("error");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childDeletedError"));
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
        setSeverity("error");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.childDeletedError"));
        handleCloseDeleteModal();
        console.log(error);
      });
  };
  return (
    <Dialog open={openDeleteModal} onClose={handleCloseDeleteModal}>
      <CloseIcon
        fontSize="medium"
        onClick={handleCloseDeleteModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogTitle>
        <Typography variant="h4" mb={1}>
          {t("headings.removeChild")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="string" mb={1}>
          {t("messages.profile.removeChild")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => deleteHandler()}
          style={{
            marginTop: "15px",
            color: "white",
            background: "red",
          }}
        >
          {t("buttonTitles.remove")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const PaymentSuccessModal = ({ openPaymentSuccessModal, handleClosePaymentSuccessModal, t }) => {
  return (
    <Dialog open={openPaymentSuccessModal} onClose={() => handleClosePaymentSuccessModal()}>
      <CloseIcon
        fontSize="medium"
        onClick={() => handleClosePaymentSuccessModal()}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogContent>
        <Typography variant="h4" ma={1}>
          {t("messages.subscription.paymentCompleted")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => handleClosePaymentSuccessModal()}
          style={{
            marginTop: "15px",
            color: "white",
            background: "#10B0D5",
          }}
        >
          {t("buttonTitles.finish")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Add i18N Translations when we work on this Modal
const ChildSummaryModal = ({
  openChildSummaryModal,
  handleCloseChildSummaryModal,
  profile,
  setOpenSnackbar,
  setAlertMessage,
  setSeverity,
  setSessionExpired,
  t,
}) => {
  const [activity, setActivity] = useState("weekly");
  const [isLoading, setIsLoading] = useState(false);
  const data = profile;
  profile.learner_activity_email = activity;
  const activityHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    call(`users/${profile.id}`, "PUT", {
      body: data,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response.status == 200) {
          setIsLoading(false);
          setSeverity("success");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.SubscriptionAddedSuccessfully"));
          handleCloseChildSummaryModal();
        } else if (response.status == 403 || response.status == 404 || response.status == 400) {
          setIsLoading(false);
          setSeverity("error");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.SubscriptionAddedError"));
          handleCloseChildSummaryModal();
        } else if (response.status == 440) {
          setIsLoading(false);
          setSessionExpired(true);
          handleCloseChildSummaryModal();
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
        setIsLoading(false);
        setSeverity("error");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.SubscriptionAddedError"));
        handleCloseChildSummaryModal();
      });
  };
  return (
    <Dialog open={openChildSummaryModal} onClose={handleCloseChildSummaryModal}>
      <CloseIcon
        fontSize="medium"
        onClick={handleCloseChildSummaryModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogTitle>
        <Typography variant="h4" mb={1}>
          Learners Actvity Summary
        </Typography>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={activityHandler}>
          <Typography variant="text" ma={1}>
            How often would you like to receive your learners' activity summary:
          </Typography>
          <FormControl fullWidth>
            <Select
              style={{ height: "48px" }}
              value={activity}
              onChange={(e) => setActivity(e.target.value)}
              name="activity"
            >
              <MenuItem value="weekly">Weekly</MenuItem>
              <MenuItem value="biweekly">Biweekly</MenuItem>
              <MenuItem value="monthly">Monthly</MenuItem>
              <MenuItem value="never">Never</MenuItem>
            </Select>
          </FormControl>

          <MDBox display="flex" justifyContent="end">
            <Button
              type="submit"
              style={{
                color: "white",
                background: "#10B0D5",
                marginTop: "15px",
                display: "flex",
                justifyContent: "end",
              }}
            >
              {isLoading ? <CircularProgress color="white" size={20} /> : "Submit"}
            </Button>
          </MDBox>
        </form>
      </DialogContent>
    </Dialog>
  );
};

const ResetPasswordDialog = ({
  openResetPasswordDialog,
  CloseResetPasswordDialogHandler,
  selectUserId,
  setOpenSnackbar,
  setAlertMessage,
  setSessionExpired,
  t,
}) => {
  const ResetHandler = () => {
    call(`users/${selectUserId}/resetpassword`, "POST", {})
      .then((res) => {
        if (res.status == 200) {
          setOpenSnackbar(true);
          setAlertMessage(
            `Reset Password is successfull- New Password is ${res.data.new_password}`
          );
        } else if (res.status == 440) {
          CloseResetPasswordDialogHandler();
          setSessionExpired(true);
        } else if (res.status == 404) {
          setOpenSnackbar(true);
          setAlertMessage(`Error while reseting the password`);
        }
        CloseResetPasswordDialogHandler();
      })
      .catch((err) => {
        Sentry.captureException(err);
        CloseResetPasswordDialogHandler();
      });
  };
  return (
    <Dialog
      open={openResetPasswordDialog}
      onClose={CloseResetPasswordDialogHandler}
      maxWidth={"md"}
    >
      <DialogTitle> {t("resetPassword.title")} </DialogTitle>

      <DialogContent>{t("resetPassword.message")}</DialogContent>

      <DialogActions>
        <Button onClick={ResetHandler} style={{ color: "white", background: "#10B0D5" }}>
          {t("buttonTitles.reset")}
        </Button>
        <Button
          onClick={CloseResetPasswordDialogHandler}
          style={{ color: "white", background: "#ED5F72" }}
        >
          {t("buttonTitles.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ChildrenTable.defaultProps = {
  childrenDetails: [],
  getChildrens: () => {},
};

ChildrenTable.propTypes = {
  childrenDetails: PropTypes.array,
  getChildrens: PropTypes.func,
};

export default ChildrenTable;
